import { IPromise, IScope } from "angular";
import { IModalScope, IModalService } from "angular-ui-bootstrap";
import { IStateInit } from "@gtmhub/core/routing";
import { ApmSpanService } from "@gtmhub/core/tracing/apm-span.service";
import { IIndicator, UIErrorHandlingService } from "@gtmhub/error-handling";
import { BadgeAssignment } from "@webapp/badges/models/badges.models";
import { ICollection } from "@webapp/core/core.models";
import { IBadge, IBadgeAssignment } from "../models/badges";
import { BadgeService } from "../services/badges";
import { BadgesModalsService } from "../services/badgesModals";
import { Ng1ConfirmBadgeActionService } from "../services/ng1-confirm-badge-action.service";

interface IAwardedBadgeScope extends IModalScope {
  indicators: {
    loading?: IIndicator;
  };
  badgeAssignments: ICollection<IBadgeAssignment>;
}

interface IBadgesScope extends IScope {
  indicators: { gettingBadges?: IIndicator };
  badges: ICollection<IBadge>;
  openDeleteDialog(badgeId: string): void;
  openAwardedDialog(badgeId: string): void;
  openAwardDialog(badgeId: string): void;
}

export class BadgesCtrl implements IStateInit {
  public static $inject = ["$scope", "$uibModal", "BadgeService", "BadgesModalsService", "ApmSpanService", "UIErrorHandlingService", "Ng1ConfirmBadgeActionService"];

  constructor(
    private $scope: IBadgesScope,
    private $uibModal: IModalService,
    private badgeService: BadgeService,
    private badgesModalsService: BadgesModalsService,
    private apmSpanService: ApmSpanService,
    private errorHandlingService: UIErrorHandlingService,
    private confirmBadgeActionService: Ng1ConfirmBadgeActionService
  ) {
    this.$scope.openDeleteDialog = this.openDeleteDialog;
    this.$scope.openAwardedDialog = this.openAwardedDialog;
    this.$scope.openAwardDialog = this.openAwardDialog;
    this.$scope.$on("accountBadgesUpdated", this.getBadges);
    this.$scope.indicators = {};
  }

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private init = (): IPromise<unknown> => {
    return this.apmSpanService.dataLoadSpan("init-badges-screen", () => this.getBadges());
  };

  private openDeleteDialog = (badgeId: string) => {
    this.badgeService.getBadgeAssignments([], [], badgeId).then(
      (badgeAssignmentsCol) => {
        this.confirmBadgeActionService.confirmDelete({
          badgeAssignments: badgeAssignmentsCol.items as BadgeAssignment[],
          action: () => Promise.resolve(this.badgeService.deleteBadge(badgeId).then(() => this.getBadges())),
        });
      },
      (err) => {
        this.errorHandlingService.handleModal(err);
      }
    );
  };

  private openAwardedDialog = (badgeId: string) => {
    this.$uibModal.open({
      template: require("../views/awarded.html"),
      windowClass: "medium-small",
      controller: [
        "$scope",
        "BadgeService",
        function ($scope: IAwardedBadgeScope, badgeService: BadgeService) {
          $scope.indicators = { loading: { progress: true } };

          badgeService.getBadgeAssignments([], [], badgeId).then(
            (badgeAssignments) => {
              $scope.badgeAssignments = badgeAssignments;
              delete $scope.indicators.loading;
            },
            (error) => {
              $scope.indicators.loading = { error };
            }
          );
        },
      ],
    });
  };

  private openAwardDialog = (badgeId: string): void => {
    this.badgesModalsService.openAwardDialog({ badgeId });
  };

  private getBadges = (): IPromise<void> => {
    this.$scope.indicators.gettingBadges = { progress: true };

    return this.badgeService.getBadges().then(
      (badges) => {
        delete this.$scope.indicators.gettingBadges;

        const emptyBadgeCollection: ICollection<IBadge> = {
          items: [],
          totalCount: 0,
        };
        this.$scope.badges = badges ? badges : emptyBadgeCollection;
        this.$scope.badges.items = this.$scope.badges.items ? this.$scope.badges.items : [];
        this.$scope.badges.items.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
      },
      (error) => {
        this.$scope.indicators.gettingBadges = { error };
      }
    );
  };
}
